import { create } from 'zustand';

// The document the citation viewer has open, so a citation badge for that same document can skip its
// hover preview: the reader is already looking at the real thing.
type State = {
  attachmentId: string | null;
  actions: { setOpen: (attachmentId: string | null) => void };
};

const useOpenCitationDocumentStore = create<State>((set) => ({
  attachmentId: null,
  actions: { setOpen: (attachmentId) => set({ attachmentId }) },
}));

export const useOpenCitationDocument = () => useOpenCitationDocumentStore((state) => state.attachmentId);
export const useOpenCitationDocumentActions = () => useOpenCitationDocumentStore((state) => state.actions);
